'use client';

import { useState, useRef, useEffect } from 'react';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import styles from './ScrollableProductList.module.scss';


export default function ScrollableProductList({ children }) {

  const [showLeftScroll, setShowLeftScroll] = useState(false);
  const [showRightScroll, setShowRightScroll] = useState(false);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    // Function to check if scrolling is needed based on the container's scroll position
    const checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      setShowLeftScroll(scrollLeft > 0);
      setShowRightScroll(scrollLeft < scrollWidth - clientWidth);
    };

    const container = scrollContainerRef.current;
    // Add event listeners for scroll and resize events
    container.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    // Initial check for scroll position
    checkScroll();

    // Clean up event listeners on component unmount
    return () => {
      container.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  // Function to handle scrolling in a specific direction
  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    const scrollAmount = container.clientWidth * 0.8;
    container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  };

  // Function to handle mouse move event and trigger scrolling based on mouse position
  const handleMouseMove = (event) => {
    const container = scrollContainerRef.current;
    const { left, right } = container.getBoundingClientRect();
    const mouseX = event.clientX;
    const threshold = 100; // Adjust this value to change the scroll sensitivity

    if (mouseX < left + threshold) {
      scroll(-1); // Scroll left if mouse is near the left edge
    } else if (mouseX > right - threshold) {
      scroll(1); // Scroll right if mouse is near the right edge
    }
  };

  return (
    <div className={styles.scrollContainer} onMouseMove={handleMouseMove}>
      {showLeftScroll && (
        <button
          className={`${styles.scrollButton} ${styles.left}`}
          onClick={() => scroll(-1)}
          aria-label="Scroll products left"
        ><ChevronLeftIcon/></button>
      )}

      <div className={styles.productList} ref={scrollContainerRef}>{children}</div>

      {showRightScroll && (
        <button
          className={`${styles.scrollButton} ${styles.right}`}
          onClick={() => scroll(1)}
          aria-label="Scroll products right"
        ><ChevronRightIcon/></button>
      )}
    </div>
  );
}
